<template>
  <v-row>
    <v-col cols="12" lg="12">
      <!-- <SumarryReports isActive="activated"></SumarryReports> -->
    </v-col>
    <v-col cols="12" lg="12">
      <v-card>
        <v-toolbar flat>
          <v-col cols="12" class="px-0">
            <div class="d-flex align-center">
              <div class="text-left">
                <v-toolbar-title class="page-title">
                  Release ONU
                </v-toolbar-title>
              </div>
              <div class="ml-auto">
                <!-- <v-btn color="primary" @click="addOlt()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add
                </v-btn> -->
                <!-- <v-btn color="primary" class="ml-2" @click="goBack()">
                  <v-icon class="mr-2">mdi-plus</v-icon> Add Serial
                </v-btn> -->
              </div>
            </div>
          </v-col>
          <v-spacer></v-spacer>
        </v-toolbar>

        <v-divider></v-divider>

        <v-card-title>
          <v-text-field
            v-model="serial"
            append-icon="mdi-magnify"
            label="Search Serial"
            single-line
            hide-details
            @keypress.enter.prevent="searchSerial()"
          ></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="table.headers"
          :items="table.data"
          :items-per-page="10"
          :loading="table.loading"
          item-key="id"
          :search="search"
          loading-text="Loading... Please wait"
          class="elevation-1"
        >
          <template
            v-for="header in table.headers.filter((header) =>
              header.hasOwnProperty('formatter')
            )"
            v-slot:[`item.${header.value}`]="{ value }"
          >
            {{ header.formatter(value) }}
          </template>

          <template v-slot:[`item.referenceNumber`]="{ item }">
            <a href="#" @click.prevent="searchOnu(item)">{{
              item.referenceNumber
            }}</a>
          </template>

          <template v-slot:[`item.isPostpaid`]="{ item }">
            {{ item.isPostpaid ? "Postpaid" : "Prepaid" }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <!-- <a @click="viewDrawDetail(item)">{{ item.name }}</a> -->
            <!-- <v-btn
              x-small
              color="primary"
              class="mr-1"
              dark
              @click="checkDuplicate(item)"
            >
              Check Duplicate</v-btn
            > -->

            <v-btn x-small color="warning" dark @click="releaseOnu(item)">
              Release</v-btn
            >
          </template>
        </v-data-table>
      </v-card>
    </v-col>
    <OnuList ref="onuList" />
    <OnuIdUpdate ref="onuIdUpdate" />
    <snackbar></snackbar>
  </v-row>
</template>

<script>
// import moment from "moment";
import OnuList from "../dialogs/management/OnuList.vue";
import OnuIdUpdate from "../dialogs/management/OnuIdUpdate.vue";
import Snackbar from "../dialogs/Snackbar.vue";
export default {
  name: "OltList",
  components: {
    OnuList,
    OnuIdUpdate,
    Snackbar,
  },
  data() {
    return {
      search: "",
      serial: "",
      table: {
        expanded: [],
        singleExpand: false,
        // sortBy: "dtCreated",
        sortDesc: true,
        loading: false,
        headers: [
          {
            text: "Serial Number",
            sortable: false,
            value: "serialNumber",
          },
          {
            text: "ONU Type",
            sortable: false,
            value: "onuType",
          },
          { text: "Frame", sortable: false, value: "frame" },
          { text: "Slot", sortable: false, value: "slot" },
          { text: "Port", sortable: false, value: "port" },
          { text: "ONT Id", sortable: false, value: "ontId" },
          { text: "OLT Name", sortable: false, value: "oltName" },
          { text: "Postpaid / Prepaid", sortable: false, value: "isPostpaid" },

          {
            text: "Actions",
            sortable: false,
            value: "action",
            align: "center",
          },
        ],
        data: [],
      },
    };
  },
  // props: ["tableAPIUrl", "reload", "headers"],

  methods: {
    async searchSerial() {
      this.table.loading = true;
      await this.$drs
        .post("/broker/pf-int/search-onu", { serialNumber: this.serial })
        .then((response) => {
          const newArr = response.data.data.list;
          console.log(newArr);
          this.table.data = newArr;
          this.table.loading = false;
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
    },

    async releaseOnu(item) {
      const payload = {
        serialNumber: item.serialNumber,
        frame: item.frame,
        slot: item.slot,
        port: item.port,
        onuId: item.ontId,
        oltName: item.oltName,
      };

      await this.$drs
        .post("/broker/pf-int/release-onu", payload)
        .then((response) => {
          const res = response.data;

          if (!res.status) {
            this.$store.dispatch("addSnackbarMessage", res.message);
            this.$store.dispatch("addSnackbar", true);
            return;
          }

          this.$store.dispatch("addSnackbarMessage", res.message);
          this.$store.dispatch("addSnackbar", true);
          this.searchSerial();
        })
        .catch((e) => {
          this.table.loading = false;
          console.log(e);
        });
      // await this.$refs.onuList.open(list);
    },
  },
  created() {
    // this.getList();
    // console.log(this.$props.headers);
  },

  watch: {
    // reload(val) {
    //   this.getDrawList(val);
    // },
  },

  computed: {
    // getPartner() {
    //   return this.$store.getters.getPartner;
    // },
  },
};
</script>

<style scoped>
.p-0 {
  padding: 0px !important;
}

.sub-areas > div > table > thead > tr {
  background-color: red;
  border-radius: 10px;
}
</style>
